import { Icon } from '@garnet/ui';
import { PhoneButton } from './PhoneChrome.js';

/**
 * Carrier scanner affordance (PRD §14.3): a camera viewport with the reticle corners and a
 * scan line. A tap stands in for a live DataMatrix/barcode decode in this offline demo;
 * on success it shows the decoded carrier string.
 */
export function Scanner({ carrier, scanned, onScan }: { carrier: string; scanned: boolean; onScan: () => void }) {
  const corner = [
    { top: 14, left: 14, borderRight: 0, borderBottom: 0 },
    { top: 14, right: 14, borderLeft: 0, borderBottom: 0 },
    { bottom: 14, left: 14, borderRight: 0, borderTop: 0 },
    { bottom: 14, right: 14, borderLeft: 0, borderTop: 0 },
  ] as const;
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div
        style={{
          position: 'relative',
          height: 150,
          background: '#0d1014',
          borderRadius: 10,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {corner.map((pos, i) => (
          <span
            key={i}
            aria-hidden="true"
            style={{ position: 'absolute', width: 22, height: 22, border: '2px solid var(--verified)', borderRadius: 3, ...pos }}
          />
        ))}
        <div
          style={{
            textAlign: 'center',
            color: scanned ? '#a7e0d2' : 'rgba(255,255,255,.6)',
            fontFamily: 'var(--mono)',
            fontSize: 12,
            padding: '0 14px',
          }}
        >
          {scanned ? (
            <>
              <Icon name="check" size={18} />
              <div style={{ marginTop: 4, wordBreak: 'break-all' }}>{carrier}</div>
              <div style={{ fontSize: 10, opacity: 0.7 }}>DataMatrix · carrier decoded</div>
            </>
          ) : (
            <>
              scan UDI carrier
              <div style={{ fontSize: 10, opacity: 0.7, marginTop: 2 }}>barcode · DataMatrix · part marking</div>
            </>
          )}
        </div>
      </div>
      {!scanned && (
        <PhoneButton primary full onClick={onScan}>
          <Icon name="scan" size={15} />
          Scan carrier
        </PhoneButton>
      )}
    </div>
  );
}
